import { IIFrameAnalyticsEventData } from '@formsort/constants';

export const FormsortFlows = {
  USA: {
    HivCareIntake: 'usa-hiv-screener',
    // eslint-disable-next-line @pm/architecture/no-brand-logic
    PrepIntake: 'freddie-usa-questionnaire',
    // eslint-disable-next-line @pm/architecture/no-brand-logic
    SEQ: 'freddie-usa-seq',
    HivWelcomeCall: 'intake-us-welcome-call-hiv',
    InsuranceIntake: 'usa-general-insurance-intake',
  },
} as const;

export const FormsortStepIds = {
  QuestionnaireSubmitted: 'questionnaire_submitted',
} as const;

export type FormsortFlow = keyof typeof FormsortFlows;

export type FlowEventPayload = Omit<
  IIFrameAnalyticsEventData,
  'type' | 'createdAt' | 'eventType'
>;
